define(function (require) {

    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var AppInstall = require('web-agent-assets-js/lpAppInstall');
    var lpBaseInfoController = require('web-agent-assets-js/lpBaseInfoController');
    var lpUtils =  require('utils/lpUtils');

    var lpAppInstallController = function (model) {
        this.applicationType = "lpAppInstallController";
        var logger = WebAgentLogger.getLogger(this.applicationType);

        var appInstallApi;

        this.getAppInstall = function (data) {
            getAppInstall(data);
        };

        this.getSingleAppInstallObject = function (appInstallObject, name) {
            return getSingleAppInstallObject(appInstallObject, name);
        };

        initializeApi();

        function initializeApi() {
            appInstallApi = new AppInstall();
        }

        /////////////////////////////// APP INSTALL DATA ///////////////////////////////////

        function getAppInstall(data) {
            logger.info("", "getAppInstall", data);
            var id;
            if (data) {
                id = data.id;
            }
            if (id) {
                var requestObj = {
                    success: lpUtils.callbackContextWrapper(handleAppInstallSuccess, data),
                    error: lpUtils.callbackContextWrapper(handleAppInstallError, data),
                    context: data
                };
                appInstallApi.getAppInstall(requestObj, id);
            }
        }

        function handleAppInstallSuccess(data) {
            logger.info("AppInstall return as Success", "handleAppInstallSuccess");
            var context = data && data.context;
            var dataObject = (data && data.dataObject) || (context && context.dataObject);
            lpAppInstallController.prototype.handleACRequestSuccess(model, data, lpAppInstallController.prototype.serviceNames.appInstall, getSingleAppInstallObject, context, dataObject);
        }

        function handleAppInstallError(data) {
            logger.error("", "handleAppInstallError", data);
            logger.graph({name: 'handleAppInstallError'});
            var context = data && data.context;
            var dataObject = (data && data.dataObject) || (context && context.dataObject);
            lpAppInstallController.prototype.handleRequestError(model, data, lpAppInstallController.prototype.serviceNames.appInstall, data && data.visitorId, dataObject);
        }

        function getSingleAppInstallObject(appInstallObject, name) {
            var toReturn = lpAppInstallController.prototype.getDataFromModelIfNotModified(model, this, name) || {
                id: appInstallObject.client_id,
                name: appInstallObject.client_name,
                description: appInstallObject.description
            };
            var visitorId = appInstallObject.visitorId || (appInstallObject.dataObject && appInstallObject.dataObject.data && appInstallObject.dataObject.data.visitorId);
            lpAppInstallController.prototype.addToVisitorInfoById(model, 'engagement.source', toReturn, visitorId, appInstallObject && appInstallObject.dataObject, lpAppInstallController.prototype.serviceNames.appInstall);
            return toReturn;
        }
    };

    lpAppInstallController.prototype = new lpBaseInfoController();

    return lpAppInstallController;
});

